<script setup lang="ts">
import { computed, ref } from "vue";

import { useBrandStore } from "@/stores";

import RetentionActionPopover from "./RetentionActionPopover.vue";
import RetentionQuickExtensionForm from "./RetentionQuickExtensionForm.vue";

const brandStore = useBrandStore();

const options = computed(() => brandStore.viewerConfig.retention?.quickExtensionOptions ?? []);

const isInFlight = ref<string>();
</script>
<template>
  <div v-if="options.length > 0" class="tw-flex tw-flex-wrap tw-gap-2">
    <span class="tw-w-full tw-text-xs">Quick Extensions</span>
    <RetentionActionPopover
      v-for="option in options"
      :key="option.label"
      side="bottom"
      align="center"
      class="tw-max-w-sm"
    >
      <template #trigger>
        <button type="button" class="tw-btn-md-gray tw-b-r tw-text-xs" :disabled="isInFlight != null">
          {{ option.label }}
        </button>
      </template>
      <RetentionQuickExtensionForm v-model:is-in-flight="isInFlight" :option="option" />
    </RetentionActionPopover>
  </div>
</template>
